import debug from "debug";

import { isServerSide } from "@jti/fe-common";

import { MessageBus } from "./MessageBus";

declare global {
  interface Window {
    jti?: {
      messageBus?: MessageBus;
      lastRequestId?: number;
    };
  }
}

const log = debug("desjti:messageBusHandler");

export const getMessageBus = (): MessageBus => {
  if (isServerSide()) {
    return new MessageBus();
  }
  if (!window.jti) {
    window.jti = {};
  }
  const messageBus = new MessageBus();

  if (!window.jti.messageBus) {
    log("[MESSAGE-BUS] The library is starting. Version: v", messageBus.getVersion());
    window.jti.messageBus = messageBus;
  }

  if (messageBus.getVersion() > window.jti.messageBus.getVersion()) {
    log(
      "[MESSAGE-BUS] The instance of the messageBus has been found with lower version and replaced. Current version is v",
      messageBus.getVersion()
    );

    window.jti.messageBus = messageBus;
  }

  return window.jti.messageBus;
};

let serverLastRequestId = 0;

// The sequence lives on window so every bundle and bus version shares it.
export const createRequestId = (): string => {
  if (isServerSide()) {
    serverLastRequestId += 1;

    return String(serverLastRequestId);
  }

  window.jti = window.jti ?? {};
  window.jti.lastRequestId = (window.jti.lastRequestId ?? 0) + 1;

  return String(window.jti.lastRequestId);
};
